import React, { useState, useEffect, useRef } from "react";
import "./menu.css";
import UserDetailsTable from "./userDetailsTable";
import { Link } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoMenu } from "react-icons/io5";
import { BiQrScan } from "react-icons/bi";
import { LuUserCog } from "react-icons/lu";
import { FaUserPlus } from "react-icons/fa";
import { SlNote } from "react-icons/sl";
import { AiFillSchedule } from "react-icons/ai";
import { toast } from "react-toastify";
import qr from "../../assets/qrcode.png";
import html2pdf from "html2pdf.js";

function Menu() {
  const [popupnewuser, setpopupnewuser] = useState("");
  const [userdetails, setuserdetails] = useState([]);
  const [users, setusers] = useState([]);

  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserDetailsOpen, setisUserDetailsOpen] = useState(false);
  // const [isreport, setisreport] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const [clientlist, setclientlist] = useState([]);

  // const storedUserDetails = localStorage.getItem("userdetails");
  // const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const [newuser, setnewuser] = useState({
    name: "",
    clientname: "",
    contact: "",
    email: "",
    shifttype: "",
    role: "",
    password: "",
    confirmpassword: "",
  });

  const [clientid, setclientid] = useState({
    clientid: "",
    role: "",
  });

  const [error, seterror] = useState({
    confirmpassword: "",
  });

  const contentRef = useRef();

const handleDownload = () => {
  const element = contentRef.current;

  // Add pdf-mode class temporarily
  element.classList.add("pdf-mode");

  const opt = {
    margin: 0.5,
    filename: "ticket-info.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  html2pdf()
    .set(opt)
    .from(element)
    .save()
    .then(() => {
      // Remove the pdf-mode class after download
      element.classList.remove("pdf-mode");
    });
};


  // user create
  const handleCreateUser = async (e) => {
    e.preventDefault();
    const requiredFieldsFilled =
      (newuser?.name &&
        newuser?.contact &&
        newuser?.email &&
        newuser?.role &&
        newuser?.password &&
        newuser?.confirmpassword) ||
      (["imanager", "icoordinator", "support"].includes(newuser.role)
        ? newuser.shifttype
        : true);

    if (!requiredFieldsFilled) {
      alert("Please enter all the required fields");
      return;
    }

    if (newuser.password !== newuser.confirmpassword) {
      seterror((prev) => ({
        ...prev,
        confirmpassword: "Please ensure both passwords match!",
      }));
      setnewuser((prev) => ({
        ...prev,
        password: "",
        confirmpassword: "",
      }));
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createuser.php`;
    const formData = new FormData();

    formData.append("user_name", newuser.name);
    formData.append("email", newuser.email);
    formData.append("password", newuser.password);
    formData.append("phone_no", newuser.contact);
    formData.append("role", newuser.role);

    if (["imanager", "icoordinator", "support"].includes(newuser.role)) {
      formData.append("current_shift", newuser.shifttype);
      formData.append("assign_id", userDetails?.userid);
    } else {
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      setnewuser({
        name: "",
        clientname: "",
        contact: "",
        email: "",
        shifttype: "",
        role: "",
        password: "",
        confirmpassword: "",
      });
      // seterror({
      //   confirmpassword: "",
      // });
      setpopupnewuser("");
      getuserdetails();
      toast.success(data.message);
    } catch (error) {
      console.log("Error with POST request:", error);
    }
  };

  const getuserdetails = async () => {
    // const selectedClient = clientlist.find(
    //   (item) => item.id === clientid.clientid
    // );
    // setclientid((pv) => ({
    //   ...pv,
    //   client_name: selectedClient?.client_name || userDetails?.client_name,
    // }));

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getuserdetails.php`;
    const formData = new FormData();

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.message === "Records fetched successfully") {
        const fetchedData = data.data || [];

        // Filter logic:
        const filteredUsers =
          userDetails?.role === "cmanager"
            ? fetchedData.filter(
                (item) =>
                  item.client_id?.toString() ===
                  userDetails.clientid?.toString()
              )
            : clientid?.role !== "client"
            ? fetchedData.filter((item) => item.role === clientid.role)
            : fetchedData.filter(
                (item) =>
                  item.client_id?.toString() === clientid.clientid?.toString()
              );

        setuserdetails(filteredUsers);
        setusers(data.data);
      } else {
        setuserdetails([]);
        setusers([]);
        alert(data.message || "No records found");
      }
    } catch (error) {
      console.error("Error with POST request:", error);
    }
  };

  useEffect(() => {
    getuserdetails();
    setuserdetails();
    setusers();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setaddactpopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="admin-portal-container">
        <div className="admin-portal-menu">
          <div className="admin-portal-menu-dropdown">
            <button
              className="admin-portal-menu-button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <IoMenu className="admin-portal-svg-icon" />
            </button>

            {isMenuOpen && (
              <div className="admin-portal-menu-box" ref={menuRef}>
                {userDetails?.role !== "icoordinator" && (
                  <>
                    <button
                      className="admin-portal-menu-item"
                      onClick={() => setpopupnewuser("newuser")}
                    >
                      <FaUserPlus /> CREATE NEW USERS
                    </button>

                    <button
                      className="admin-portal-menu-item"
                      onClick={() => {
                        setpopupnewuser("modifyuser");
                        getuserdetails();
                      }}
                    >
                      <LuUserCog /> MODIFY & UPDATE
                    </button>
                  </>
                )}

                <Link to="/reports" state={{ users }}>
                  <button className="admin-portal-menu-item">
                    <SlNote /> REPORTS
                  </button>
                </Link>

                {userDetails?.role !== "cmanager" && (
                  <Link to="/shiftschedule" state={{ users }}>
                    <button className="admin-portal-menu-item">
                      <AiFillSchedule /> SHIFT SCHEDULE
                    </button>
                  </Link>
                )}
                <button
                  className="admin-portal-menu-item"
                  onClick={() => {
                    setpopupnewuser("scanqr");
                    getuserdetails();
                  }}
                >
                  <BiQrScan /> SCAN ME
                </button>
              </div>
            )}
          </div>

          {/* create user  */}
          {popupnewuser === "newuser" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Create New User</h2>
                </div>

                <div className="admin-portal-form-section">
                  <form
                    onSubmit={handleCreateUser}
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    <span className="admin-portal-label">Role: </span>
                    <select
                      required
                      className="admin-portal-select"
                      value={newuser?.role}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          role: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      <option value="imanager">Support Manager</option>
                      <option value="icoordinator">Support Coordinator</option>
                      <option value="support">Support Team</option>
                    </select>

                    <span className="admin-portal-label">User Name: </span>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      required
                      value={newuser?.name}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          name: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    <span className="admin-portal-label">Contact No: </span>
                    <input
                      type="tel"
                      pattern="[0-9]{10}"
                      title="Please enter exactly 10 digits"
                      placeholder="Enter Contact"
                      required
                      value={newuser?.contact}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          contact: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    <span className="admin-portal-label">Email: </span>
                    <input
                      type="email"
                      placeholder="Enter Email"
                      required
                      value={newuser?.email}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          email: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    <span className="admin-portal-label">Shift type: </span>
                    <select
                      required
                      className="admin-portal-select"
                      value={newuser?.shifttype}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          shifttype: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled defaultChecked>
                        Select Shift
                      </option>

                      <option value={"General Shift - GS"}>
                        General Shift - GS
                      </option>
                      <option value={"First Shift - S1"}>
                        First Shift - S1
                      </option>
                      <option value={"Second Shift - S2"}>
                        Second Shift - S2
                      </option>
                      <option value={"Third Shift - S3"}>
                        Third Shift - S3
                      </option>
                    </select>

                    <span className="admin-portal-label">Password: </span>
                    <input
                      type="password"
                      placeholder="Enter Password"
                      required
                      className="admin-portal-input"
                      value={newuser?.password}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          password: e.target.value,
                        }))
                      }
                    />

                    <span className="admin-portal-label">
                      Confirm Password:{" "}
                    </span>
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      required
                      className="admin-portal-input"
                      value={newuser?.confirmpassword}
                      onChange={(e) => {
                        setnewuser((pv) => ({
                          ...pv,
                          confirmpassword: e.target.value,
                        }));

                        if (newuser?.password === e.target.value) {
                          seterror((prev) => ({
                            ...prev,
                            confirmpassword: "",
                          }));
                        }
                      }}
                    />
                    {error.confirmpassword && (
                      <p className="error-msg">{error.confirmpassword}</p>
                    )}

                    <button type="submit" className="admin-portal-btn-create">
                      Create
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* create user  */}
          {popupnewuser === "modifyuser" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Modify User</h2>
                </div>

                <div className="admin-portal-form-section">
                  <div
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    {userDetails?.role != "cmanager" && (
                      <>
                        <span className="admin-portal-label">Role: </span>
                        <select
                          required
                          className="admin-portal-select"
                          value={clientid?.role}
                          onChange={(e) =>
                            setclientid((pv) => ({
                              ...pv,
                              role: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled>
                            Select Role
                          </option>

                          <option value={"imanager"}>IT Manager</option>
                          <option value={"icoordinator"}>
                            IT Co-ordinator
                          </option>
                          <option value={"support"}>Support</option>
                        </select>

                        <button
                          onClick={() => (
                            getuserdetails(), setisUserDetailsOpen(true)
                          )}
                          className="admin-portal-btn-create"
                        >
                          Get Users
                        </button>
                      </>
                    )}

                    {isUserDetailsOpen && (
                      <div className="admin-portal-user-details">
                        {/* <h3>User Details</h3> */}

                        {isUserDetailsOpen && (
                          <UserDetailsTable
                            userdetails={userdetails}
                            getuserdetails={getuserdetails}
                            selectedcompany={
                              clientid?.role === "imanager"
                                ? "IT Manager"
                                : clientid?.role === "icoordinator"
                                ? "IT Co-ordinator"
                                : clientid?.role === "support"
                                ? "Support Teams"
                                : null
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* create user  */}
          {popupnewuser === "scanqr" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">SCAN ME</h2>
                </div>
                <button onClick={handleDownload} className="download-button">
                  Download
                </button>
                <div ref={contentRef} className="admin-ticketrise-form-section">
                  <h2 className="pdf-only">SCAN ME</h2>
                  <img src={qr} alt="Scanfdd QR Code" />
                  <div className="custom-tooltip-wrapper">
                    <a
                      href="https://ltaf.myhrsoft.com/Ticketrise"
                      target="_blank"
                      className="custom-tooltip-link"
                    >
                      Link to Raise a Ticket
                      <span className="tooltip-text">
                        https://ltaf.myhrsoft.com/Ticketrise
                      </span>
                    </a>
                  </div>

                  <h2>One Tap. One Ticket. One Solution.</h2>
                  <p>
                    Scan the QR code to quickly access our support form and
                    raise a ticket. Our team is committed to resolving your
                    issue within 24 hours. It's fast, simple, and ensures you
                    get the help you need without delay.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default Menu;
